<!-- <app-search [pagingModel]="pagingModel" [showInDialog]="showInDialog" [columnData]="columnDataResult"
    (dataViewUpdate)="queryData($event)" [selectedSearchArea]="selectedSearchArea" [searchKeyword]="searchKeyword"/> -->
<p-toast></p-toast>

<h1>Expense Search</h1>

<div class="grid mb-5">
    <div class="col-12 sm:col-6 align-items-center">
        <p-inputGroup>
            <rc-input id="searchQuickfind" 
                type="text" 
                [classes]="['input-quickfind']" 
                placeholder="Quick Search..."
                [control]="filterValue"
                data-cy="input-quickfind"/>
            <button type="button" pButton icon="pi pi-search" class="btn-quickfind" (click)="onPageSearch()" data-cy="btn-quickfind"></button>
        </p-inputGroup>
    </div>
    <div class="col-12 sm:col-6 align-items-center sm:text-right">
        <rc-generic-button label="Add New Expense" 
            id="button-add-expense" 
            level="secondary"
            size="large"
            (click)="onAddExpense()"
            data-cy="btn-add-expense"/>
    </div>
</div>

<p-card>
    <div id="search-column-toggle" class="flex vertical">
        <button class="btn-toggle-expand {{ isExpanded ? 'icon-minimize' : 'icon-expand' }}"
            (click)="toggleSelectedLabels()">
        </button>
        <p-multiSelect [group]="true" [options]="groupedOptions" [(ngModel)]="selectedColumns"
            class="multi-select-columns expand-icon" scrollHeight="300px" optionLabel="displayColumn"
            optionGroupLabel="label" optionGroupChildren="items" display="chip" [maxSelectedLabels]="maxSelectedLabels"
            [selectedItemsLabel]="'{0} items selected'" placeholder="Choose Columns" id="multi-select-columns"
            [ngClass]="{'expanded': isExpanded, 'collapsed': !isExpanded}">
        </p-multiSelect>
    </div>

    <div class="search-actions grid py-2">
        <div class="col text-left">

            <p-button label="Selected" (onClick)="menu2.toggle($event)" icon="pi pi-angle-down" iconPos="right"
                severity="secondary" styleClass="mr-1 my-1" [disabled]="numberOfItemsSelected === 0" data-cy="btn-selected"></p-button>

            <p-button label="Export" icon="fa-sharp fa-light fa-download" (onClick)="onExportToExcel()"
                id="button-export" severity="secondary" [outlined]="true" styleClass="my-1" [disabled]="hasNoResults()"
                class="ml-0" data-cy="btn-export"></p-button>
            <p-menu #menu2 [popup]="true" [model]="selectedOptions"></p-menu>
        </div>
        <div class="top-paginator" *ngIf="!hasNoResults()">

            <div class="mb-3">
                <p-button type="button" icon="pi pi-chevron-left" styleClass="p-button-text mr-1 grey-text-button"
                    (onClick)="pageBack()" data-cy="btn-back"/>

                <p-button type="button" icon="pi pi-chevron-right" styleClass="p-button-text ml-1 grey-text-button"
                    (onClick)="pageForward()" data-cy="btn-forward"/>
            </div>

        </div>
        <div class="col text-right">

            <rc-generic-button label="Clear All" id="button-clear-filters" iconImg="clear-filter" borderStyle="outline"
                (click)="resetFilters()" [classes]="['my-1']" data-cy="btn-clear"/>

            <rc-generic-button label="Search" id="button-search" iconImg="search" (click)="onSearch()"
                [classes]="['my-1 ml-1']" data-cy="btn-search"/>
        </div>
        <p-menu #menu2 [popup]="true" [model]="selectedOptions"></p-menu>
    </div>

    <div style="width: 100%; min-height: 22rem;">
          <p-table 
            #resultTable 
            [value]="tableData" 
            [columns]="selectedColumns" 
            [(selection)]="selectedRows"
            selectionMode="multiple" 
            dataKey="ExpenseRequestId" 
            [paginator]="!hasNoResults()" 
            [scrollable]="true"
            scrollHeight="flex" 
            [rows]="10" 
            [rowsPerPageOptions]="[10, 25, 50, 100]" 
            [responsiveLayout]="'scroll'" 
            filter ='false'
            [reorderableColumns]="true" 
            styleClass="rc-datatable-outlined first-col-border last-col-border"
            (onFilter)="onTableFilter($event)"
            data-cy="table-data">

            <ng-template pTemplate="header" let-columns id="header-filters">
                <tr>
                    <th pFrozenColumn>
                    </th>
                    <th *ngFor="let col of columns" pReorderableColumn style="vertical-align: top;" nowrap
                        pSortableColumn={{col.columnName}} id="column-{{col.columnName}}">
                        <div class="sortable-title">
                            <div class="column-title">{{col.displayColumn}}</div>
                            <p-sortIcon field={{col.columnName}} style="cursor: pointer;"
                                id="sort-icon-{{col.columnName}}" />
                        </div>
                    </th>
                    <th alignFrozen="right" pFrozenColumn class="text-center">
                        <div class="column-title">Actions</div>
                    </th>
                </tr>
                <tr class="filter">
                    <th pFrozenColumn>
                        <p-checkbox id="checkbox-select-all" [binary]="true" [(ngModel)]="allItemsChecked"
                            (click)="checkAll()" data-cy="checkbox-select-all"/>
                    </th>
                    <th *ngFor="let col of columns" pReorderableColumn class="filter">
                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'StatusMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="ExpenseStatus" matchMode="in" [showMenu]="false"
                                showClearButton="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [(ngModel)]="selectedStatuses" [options]="columnData.statusOptions"
                                        placeholder="Select Status" (onChange)="filter($event.value)"
                                        optionValue="value" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                                        [displaySelectedLabel]="true" emptyMessage="No Status found"
                                        [selectedItemsLabel]="'{0} items selected'">
                                        <ng-template let-option pTemplate="item">
                                            <div class="inline-block vertical-align-middle">
                                                <span class="ml-1 mt-1">
                                                    {{ option.value }}
                                                </span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                        <div
                            *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'ApprovalMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="AssignedToCurrentUser" matchMode="equals" [showMenu]="false"
                                showClearButton="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [(ngModel)]="selectedapproval" [options]="columnData.approvalOptions"
                                        optionLabel="value" optionValue="key" placeholder="Select Approval"
                                        (onChange)="onApprovalChange(filter)">
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                        <div
                            *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'FundCodesMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="FundCode" matchMode="in" [showMenu]="false" showClearButton="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [(ngModel)]="selectedFundCodes" [options]="columnData.fundCodes"
                                        placeholder="Select FundCodes" (onChange)="onFundChange($event.value, filter)"
                                        optionValue="key" optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                                        [displaySelectedLabel]="true" emptyMessage="No FundCodes found"
                                        [selectedItemsLabel]="'{0} items selected'">
                                        <ng-template let-option pTemplate="item">
                                            <div class="inline-block vertical-align-middle">
                                                <span class="ml-1 mt-1">
                                                    {{ option.value }}
                                                </span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>

                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'HoldMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="Hold" matchMode="equals" [showMenu]="false" showClearButton="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [(ngModel)]="selectedHold" [options]="holdOptions" optionLabel="value"
                                        optionValue="value" placeholder="Select Hold" (onChange)="onHoldChange(filter)">
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                        <div
                            *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'CheckbooksMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <p-columnFilter field="CheckbookID" matchMode="in" [showMenu]="false"
                                showClearButton="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [(ngModel)]="selectedCheckbookIds" [options]="columnData.checkbooks"
                                        placeholder="All" filter="true"
                                        (onChange)="onCheckbookChange($event.value, filter)" optionValue="key"
                                        optionLabel="value" [maxSelectedLabels]="1" appendTo="body"
                                        [displaySelectedLabel]="true" emptyMessage="No Checbooks found"
                                        [selectedItemsLabel]="'{0} items selected'">
                                        <ng-template let-option pTemplate="item">
                                            <div class="inline-block vertical-align-middle">
                                                <span class="ml-1 mt-1">
                                                    {{ option.value }}
                                                </span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>

                        <div *ngIf="col.displayColumnType && col.displayColumnType.columnType === 'NoFilter'">
                        </div>
                        <div
                            *ngIf="col.displayColumnType && col.displayColumnType.columnType !== 'ApprovalMultiSelect' &&col.displayColumnType.columnType !== 'StatusMultiSelect' 
                            &&col.displayColumnType.columnType !== 'FundCodesMultiSelect'  &&col.displayColumnType.columnType !== 'CheckbooksMultiSelect'
                            &&col.displayColumnType.columnType !== 'NoFilter' && col.displayColumnType.columnType !== 'HoldMultiSelect'"
                             [attr.data-cy]="'filter-column-' + getSanitizedColumnName(col)">
                            <rc-table-filter [filterModel]="col.filterModel" (modelChange)="col.filterModel = $event" />
                        </div>
                    </th>
                    <th alignFrozen="right" pFrozenColumn>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowdata let-columns="columns" let-index="rowIndex">
                <tr>
                    <td pFrozenColumn>
                        <!-- <p-checkbox [value]="rowdata"></p-checkbox> -->
                        <p-checkbox id="checkbox-select-all" [binary]="true" [(ngModel)]="rowdata.isChecked"
                            (click)="check(rowdata)" />
                    </td>
                    <td class="text-center" *ngFor="let col of columns" nowrap>

                        <!-- Status -->
                        <span *ngIf="col.columnName==='ExpenseStatus'">
                            <p-tag [severity]="getSeverityAndValue(rowdata[col.columnName]).severity"
                                [value]="getSeverityAndValue(rowdata[col.columnName]).value">
                            </p-tag>
                        </span>

                        <!-- Approvals -->
                        <span *ngIf="col.columnName === 'AssignedToCurrentUser'">
                            <p-button [icon]="getGroupIcon(rowdata['ExpenseStatus'])"
                                styleClass="bg-neutral-0 p-button-lg"
                                (click)="getApprovalById(rowdata['ExpenseRequestId'], $event, my)">
                            </p-button>

                            <p-overlayPanel #my>
                                <div *ngIf="!showLoading && approvalsData.length > 0">
                                    <p *ngFor="let approval of approvalsData">
                                        <span *ngIf="approval.approvedDate">
                                            <b>{{ approval.approvedBy }}</b>
                                            ({{ approval.approvedDate | date: 'short' }})
                                        </span>
                                        <span *ngIf="!approval.approvedDate">
                                            {{ approval.approvedBy }} &mdash;
                                            <i>{{approval.status !== 'Approved' ? "Waiting" : ""}}</i>
                                        </span>
                                    </p>
                                </div>
                                <div *ngIf="!showLoading && approvalsData.length === 0">
                                    <i>No approval needed.</i>
                                </div>
                            </p-overlayPanel>
                        </span>

                        <!-- Expense ID -->
                        <span *ngIf="col.columnName === 'ExpenseRequestId'">
                            <a href="#"
                                (click)="openExistingExpense(rowdata.ExpenseRequestId); $event.preventDefault()">{{
                                rowdata[col.columnName] }}</a>
                        </span>

                        <!-- Amount -->
                        <span *ngIf="col.columnName === 'ExpenseAmount'">
                            <div class="flex justify-content-end align-items-center full-width">
                                <span class="font-bold mr-2">{{ rowdata[col.columnName] | currency: 'USD':'symbol'
                                    }}</span>
                                <p-button icon="fa-sharp fa-light fa-rectangle-list" (click)="cb.toggle($event)"
                                    styleClass="bg-neutral-0 redwood-60">
                                </p-button>

                                <p-overlayPanel #cb>
                                    <div style="max-width: 12rem;">
                                        <p *ngFor="let glDetail of rowdata.GLDetails">{{ glDetail.glAccount }}</p>
                                    </div>
                                </p-overlayPanel>
                            </div>
                        </span>

                        <!-- Attachments -->
                        <span *ngIf="col.columnName === 'Attachments' && rowdata.Attachments?.length > 0">
                            <!-- Single Attachment -->
                            <ng-container *ngIf="rowdata.Attachments.length === 1; else multipleAttachments">
                                <a href="#"
                                    (click)="onDownloadAttachement(rowdata.Attachments[0], $event); $event.preventDefault()">
                                    {{ rowdata.Attachments[0].fileName }}
                                </a>
                            </ng-container>

                            <!-- Multiple Attachments -->
                            <ng-template #multipleAttachments>
                                <div>
                                    <!-- First attachment shown directly -->
                                    <div>
                                        <a href="#"
                                            (click)="onDownloadAttachement(rowdata.Attachments[0], $event); $event.preventDefault()">
                                            {{ rowdata.Attachments[0].fileName }}
                                        </a>
                                    </div>

                                    <!-- "More..." link on new line -->
                                    <div style="margin-top: 0.5rem;">
                                        <a href="#"
                                            (click)="attachmentsOverlay.toggle($event); $event.preventDefault()">
                                            <strong>More...</strong>
                                        </a>
                                    </div>
                                </div>
                            </ng-template>

                            <!-- Overlay with rest of the attachments (excluding first one) -->
                            <p-overlayPanel #attachmentsOverlay>
                                <div *ngFor="let attachment of rowdata.Attachments.slice(1)" class="mb-2">
                                    <a href="#"
                                        (click)="onDownloadAttachement(attachment, $event); $event.preventDefault()">
                                        {{ attachment.fileName }}
                                    </a>
                                </div>
                            </p-overlayPanel>
                        </span>

                        <!-- Date with date pipe -->
                        <span *ngIf="col.columnName.toLowerCase().includes('date')">
                            {{ rowdata[col.columnName] | date: 'MM/dd/yyyy' }}
                        </span>

                        <!-- Default fallback for all other text columns -->
                        <span *ngIf="col.columnName !== 'ExpenseStatus'
                        && !col.columnName.toLowerCase().includes('amount')
                        && !col.columnName.toLowerCase().includes('date')
                        && col.columnName !== 'FileName'
                        && col.columnName !== 'AssignedToCurrentUser'
                        && col.columnName !== 'ExpenseAmount'
                        && col.columnName !== 'Attachments'
                        && col.columnName !== 'ExpenseRequestId'">
                            {{ rowdata[col.columnName] }}
                        </span>
                    </td>

                    <!-- Actions -->
                    <td alignFrozen="right" pFrozenColumn style="white-space: nowrap; padding: 1rem 0.5rem;">


                        <rc-generic-button [label]="
                                rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'My approval - locked' : 
                                rowdata['AssignedToCurrentUser'] === '1' && rowdata['MyApproval'] === '1' ? 'My approval - approved' : 
                                rowdata['AssignedToCurrentUser'] === '1' && (rowdata['MyApproval'] === '0') ? 'My approval - pending' : 
                                'My approval - not needed'" [iconImg]="
                                rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'user-check' : 
                                rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '1'? 'user-check': 
                                rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '0' ? 'user-clock' : 
                                'user-minus'" [iconColor]="
                                rowdata['AssignedToCurrentUser'] === '1' && rowdata['ExpenseStatus'] ==='Paid' ? 'gray-dark' : 
                                rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '1'? 'teal-dark': 
                                rowdata['AssignedToCurrentUser'] === '1'  && rowdata['MyApproval'] === '0' ? 'teal-medium' : 
                                'gray-light'" [disabled]="rowdata['AssignedToCurrentUser'] !== '1'" [isIconOnly]="true"
                            [classes]="['mx-1']"
                            (clickHandler)="rowdata['AssignedToCurrentUser'] === '1'&&rowdata['MyApproval'] === '0' && expenseRequestApprove(rowdata.ExpenseRequestId)" />


                        <rc-generic-button [label]="
                                rowdata['ExpenseStatus'] ==='Paid' ? 'RC Approval - sent for payment' : 
                                rowdata['ExpenseStatus'] ==='Approved' ? 'RC Approval - pending': 
                                'RC Approval - unapproved'" [iconImg]="
                                rowdata['ExpenseStatus'] ==='Paid' ? 'money-check' : 
                                rowdata['ExpenseStatus'] ==='envelope-dollar' ? 'envelope-dollar': 
                                'envelope-dollar'" [iconColor]="
                                rowdata['ExpenseStatus'] ==='Paid' ? 'teal-dark' : 
                                rowdata['ExpenseStatus'] ==='Approved' ? 'teal-medium' :
                                'gray-light'"
                            [disabled]="rowdata['ExpenseStatus'] ==='Partial' || rowdata['ExpenseStatus'] ==='Unapproved'"
                            [isIconOnly]="true" [classes]="['mx-1']"
                            (clickHandler)="rowdata['ExpenseStatus'] ==='Approved' && sendforPayment(rowdata) || rowdata['ExpenseStatus'] ==='Paid' && unapprovePayment(rowdata) " />

                        <rc-generic-button label="Delete" iconImg="trash" [iconColor]="'red-light'" [isIconOnly]="true"
                            (clickHandler)="deleteExpenseRequest(rowdata.ExpenseRequestId)" [classes]="['mx-1']" data-cy="btn-delete"/>
                    </td>

                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr *ngIf="!showLoading">
                    <td [attr.colspan]="selectedColumns.length + 2" class="text-center no-data-message">
                        {{NoDataMessage}}
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div ngClass="medium loader-wrapper" *ngIf="showLoading">
            <rc-loading-spinner></rc-loading-spinner>
        </div>
    </div>
</p-card>

<!-- confirmation dialog -->
<p-dialog [(visible)]="dialogVisible" 
    header="Confirm Action" 
    [modal]="true" 
    [closable]="false"
    styleClass="p-confirm-dialog">

    <ng-container *ngIf="dialogData && !dialogMessage; else messageText">
        <div style="display: flex; flex-direction: column; gap: 2rem">
            <div *ngIf="dialogData.approved?.records?.length">
                <p>{{ dialogData.approved.message }}</p>
                <p-table [value]="[dialogData.approved.records]" styleClass="datatable-xs">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Request IDs</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div *ngIf="dialogData.skipped?.records?.length">
                <p>{{ dialogData.skipped.message }}</p>
                <p-table [value]="dialogData.skipped.records" styleClass="datatable-xs">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Request ID</th>
                            <th>Reason</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item.requestId }}</td>
                            <td>{{ item.reason }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>

    <!-- Fallback for plain string -->
    <ng-template #messageText>
        <p>{{ dialogMessage }}</p>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="onDialogReject()" class="p-button-outlined" data-cy="btn-cancel"></button>
        <button pButton label="Confirm" (click)="onDialogAccept()" data-cy="btn-confirm"></button>
    </ng-template>
</p-dialog>

<!-- Add Expense MODAL -->
<p-dialog [(visible)]="showAddNewExpenseDialog" 
    modal="true" 
    [maximizable]="true" 
    (onShow)="onExpenseDialogOpened()"
    (onHide)="onExpenseDialogClosed()" 
    styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300">

    <ng-template pTemplate="header">
        <div class="modal-header">
            <span class="h4">
                {{ this.expenseId>0 ? 'Edit Expense' : 'Add New Expense ' }}
            </span>
            <span class="ml-3" *ngIf="this.expenseId>0">(ID: {{this.expenseId}})</span>
        </div>
    </ng-template>

    <ng-container *ngIf="showAddNewExpenseDialog">
        <expense-add-app-stepper [existingexpenseId]="selectedExpenseId"
            (closeDialog)="onCloseStepperDialog()"></expense-add-app-stepper>
    </ng-container>
</p-dialog>
